import { cssTheme } from '@uds/theme-utils';
import { classNames } from '@uds/typography';
import { css, cx } from 'linaria';

const root = {
  default: css`
    margin-bottom: 0;
    & {
      :not(:last-of-type) {
        margin-bottom: ${cssTheme.gu2};
      }
    }
  `,
};

export default () => {
  return {
    root: cx(classNames.footnote, root.default),
  };
};
